import React, { Fragment } from 'react';
import styled from 'styled-components';

const IframeContainer = styled.iframe`
    width: 100%;
    height: 170px;
    display: block;
    max-width: 80%;
    border-radius: 5px;
    margin: 30px auto 20px;
    background-color: white;
    box-shadow: 0px 0px 25px rgb(0 0 0 / 44%);
    
    @media (min-width: 768px) {
        max-width: 660px;
    }
    @media (min-width: 1150px) {
        max-width: 800px;
    }

    &.fullScreen {
        height: 600px;
    }
`

const EmbededIframe = ({toggle}) => {
    const Iframe = ( toggle )
        ? <IframeContainer className="fullScreen" frameborder="no" scrolling="no" seamless src="https://player.captivate.fm/show/bfefeba5-3713-486d-8799-d5eeea700758/" />
        : <IframeContainer frameborder="no" scrolling="no" seamless src="https://player.captivate.fm/show/bfefeba5-3713-486d-8799-d5eeea700758/latest/"/>; 

    return (
        <Fragment>
            {Iframe}
        </Fragment>
    );
};

export default EmbededIframe;
